/**
 * List Schema of ErroIntegracao
 * @author Simpli CLI generator
 */
import {
  Helper,
  Schema,
  FieldSet,
  FieldComponent,
  Component,
} from 'simpli-web-sdk'
import {ErroIntegracao} from '@/model/resource/ErroIntegracao'
import RenderCargaDanfe from '@/components/render/carga/RenderCargaDanfe.vue'

export class ListErroIntegracaoSchema extends Schema {
  readonly name = 'ListErroIntegracao'

  readonly fieldSet: FieldSet<ErroIntegracao> = {
    cnpj: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.cnpj(schema.model.responsavel?.cnpj),
        class: 'table__single-line',
      },
    }),
    razaoSocial: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.responsavel?.razaoSocial,
      },
    }),
    nf: (): FieldComponent => ({
      is: Component.Render,
    }),
    danfe: (schema): FieldComponent => ({
      is: RenderCargaDanfe,
      bind: {
        danfe: schema.model.danfe,
      },
    }),
    response: (): FieldComponent => ({
      is: Component.Render,
      bind: {
        class: 'text-danger',
      },
    }),
    quant: (): FieldComponent => ({
      is: Component.Render,
    }),
    data: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.datetime(schema.model.data),
        class: 'table__single-line',
      },
    }),
  }
}
